<template>
  <router-link
    to="/product-categories"
    class="card mx-3 mt-3 mb-3 text-decoration-none text-reset"
  >
    <div class="card-body d-flex justify-content-between align-items-center py-3">
      <div>
        <div class="fw-semibold">
          <i class="fa-solid fa-layer-group me-2 text-primary" />
          {{ $t('Category Management') }}
        </div>
        <div class="text-muted" style="font-size: 13px;">
          {{ $t('Manage menu categories and the order they appear in.') }}
        </div>
      </div>
      <i class="fa-solid fa-chevron-right text-muted" />
    </div>
  </router-link>
</template>

<script lang="js">
export default {
  name: 'ProductCategoriesSettingsCard'
};
</script>
